import {parseSignInDeepLinkHints} from "@vesta/vos-types/modules/platformLevel/authentication/domain/SignInDeepLinkHints";

export {parseSignInDeepLinkHints};
export type {SignInDeepLinkHints} from "@vesta/vos-types/modules/platformLevel/authentication/domain/SignInDeepLinkHints";

export function appendSignInDeepLinkHints({
    authorizeUrl,
    searchParams,
}: {
    authorizeUrl: URL;
    searchParams: URLSearchParams;
}): void {
    const hints = parseSignInDeepLinkHints(searchParams);
    if (hints.method === undefined) {
        return;
    }
    authorizeUrl.searchParams.set("login_method", hints.method);
    const identifier = "phoneNumber" in hints ? hints.phoneNumber : "email" in hints ? hints.email : undefined;
    if (identifier !== undefined) {
        authorizeUrl.searchParams.set("login_hint", identifier);
    }
}
